module.exports = {
      id: "speaker-usage",
      viewBox: "0 0 15 12",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#speaker",
      toString: function () {
        return this.url;
      }
    }